/* unit */
import { cfg } from '../../../config';
import { http } from '../http';
import { type ApiRsp } from '../types';

interface UnitService {
    getUnit(id: number): Promise<ApiRsp>;
    getChild(id: number): Promise<ApiRsp>;
    getTree(id: number): Promise<ApiRsp>;
    // dropdown
    setChildDropdown(id: number, elm: HTMLSelectElement): Promise<void>;
    setTreeDropdown(id: number, elm: HTMLSelectElement): Promise<void>;
}

export const unit: UnitService = {
    getUnit: (id: number) => {
        const url = cfg.hub.API + `/units/${id}`;
        return http.get(url);
    },
    getChild: (id: number) => {
        const url = cfg.hub.API + `/units/${id}/child`;
        return http.get(url);
    },
    getTree: (id: number) => {
        const url = cfg.hub.API + `/units/${id}/tree`;
        return http.get(url);
    },
    // dropdown
    setChildDropdown: async (id: number, elm: HTMLSelectElement) => {
        const resp = await unit.getChild(id);
        const data = resp.data as OrgUnit[];
        data.forEach(val => {
            const option = document.createElement('option');
            option.value = val.id.toString();
            option.textContent = val.short ? val.short : val.name;
            option.dataset.type = val.unit_type;
            elm.appendChild(option);
        });
    },
    setTreeDropdown: async (id: number, elm: HTMLSelectElement) => {
        const resp = await unit.getTree(id);
        const data = resp.data as OrgUnit[];
        mapTree(data, elm);
    }
};

const mapTree = (data: OrgUnit[], elm: HTMLSelectElement) => {
    data.forEach(val => {
        const option = document.createElement('option');
        option.value = val.id.toString();
        const indent = val.level > 1 ? "\u00A0".repeat((val.level - 1) * 2) + "- " : "";
        option.textContent = `${indent}${val.short ? val.short : val.name}`;
        option.dataset.type = val.unit_type;
        elm.appendChild(option);
        if (val.children && val.children.length > 0) {
            mapTree(val.children, elm); // children
        }
    });
};

export type UnitType = 'AGENCY' | 'DIVISION' | 'SECTION';
export type OrgUnit = {
    id: number;
    parent_id: number | null;
    unit_type: UnitType;
    code: string;
    name: string;
    short: string;
    abbr_th: string;
    abbr_en: string;
    path: string;
    level: number;
    is_active: boolean;
    children?: OrgUnit[];
};